import { Errors } from '@/constants/errors';
import { PaymentMethodEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import type { NuveiPaymentResponse } from '@/types/payment';
import { buildNuveiGenericPaymentPayload } from '@/utils/nuvei';
import { logError } from '@/utils/logger';

export const handleNuveiGenericPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: <TResponse>(params: unknown) => Promise<TResponse>,
  params: Record<string, string>
): Promise<unknown> => {
  try {
    const selectedPaymentMethod =
      checkout.paymentMethodSelected === PaymentMethodEnum.OTHER
        ? checkout.otherMethodSelected
        : checkout.paymentMethodSelected;
    const paymentMethodSettings = checkout.paymentMethodsSettings.find(
      (pm) => pm.paymentMethodName === selectedPaymentMethod
    );

    if (!paymentMethodSettings) {
      throw new Error(Errors.payment.paymentFailed);
    }
    const { sessionToken } = await checkout.actions.createSession({
      paymentMethodId: paymentMethodSettings.id || '',
      email: params.email || checkout.customer.email || '',
    });

    const payload = buildNuveiGenericPaymentPayload({
      paymentMethodSettings,
      params,
      sessionToken,
      email: checkout.customer.email || '',
    });

    const response = (await sendPaymentToServer(payload)) as NuveiPaymentResponse;
    return {
      ...response,
      sessionToken,
    };
  } catch (error) {
    logError(Errors.payment.paymentFailed, error);
    throw new Error(Errors.payment.paymentFailed);
  }
};
